class ct_popup extends HTMLElement {
  constructor() {
    super();
    const delay = parseInt(this.getAttribute("delay"));
    setTimeout(() => {
      if(!localStorage.getItem("NEWSLETTER_POPUP")) {
        this.open();
      } else {
        if(localStorage.getItem("NEWSLETTER_POPUP") !== "true") {
          const savedTime = localStorage.getItem("NEWSLETTER_POPUP");
          const currentTime = Date.now();
          const timeDifference = currentTime - savedTime;
          const thirty = 30 * 60 * 1000;
          if(timeDifference > thirty) {
            this.open();
          }
        }
      }
    }, delay);
    const closer = this.querySelector(".ct-popup-closer");
    closer.addEventListener("click", () => {
      this.close();
    });
    const overlay = this.querySelector(".ct-popup-overlay");
    overlay.addEventListener("click", (e) => {
      if(e.target !== this.querySelector(".ct-popup-wrapper")) {
        this.close();
      }
    });
  }
  close() {
    this.classList.add("ct-hidden");
    if(localStorage.getItem("NEWSLETTER_POPUP") !== "true") {
      localStorage.setItem("NEWSLETTER_POPUP", Date.now());
    }
  }
  open() {
    this.classList.remove("ct-hidden");
  }
}
customElements.define("ct-popup", ct_popup);